module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0111.jpg?v=160d5c52";